
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/device-care/onboarding",
      function () {
        return require("private-next-pages/device-care/onboarding.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/device-care/onboarding"])
      });
    }
  